import { useTranslation } from "react-i18next";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import useCrudTable from "../../../../../hooks/useCrudTable";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import { useTranslatedColumns } from "../../../../general/modules/commons/tableTranslation/translatedColumns";
import { PackingSlipTableColumns } from "../../domain/columns/PackingSlipTableColumns";
import { packingSlipListSchema } from "../../domain/schema/packingSlipSchema";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { PackingSlipTableFilters } from "../features/PackingSlipTableFilters";

export const PackingSlipPage = () => {
  const { t } = useTranslation("common");
  const title = t("Packing slip");
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.auth.user);

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootPackingSlip",
      fields: {},
    },
    "packingSlipFilter",
  );

  const translatedColumns = useTranslatedColumns(PackingSlipTableColumns);

  const crud = useCrudTable({
    prefix: "packingSlips",
    entity: "PackingSlip",
    columns: translatedColumns,
    schema: packingSlipListSchema,
    filters: crudFilters.filters,
    columnAction: "/packing-slips/edit/:id",
    defaultSorting: [
      { id: "date", desc: true },
      { id: "route.truck.licence", desc: false },
    ],
  });

  if (!currentUser) {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className={"mb-3"} />
          <PackingSlipTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
